import React , {useState} from 'react'

import axios from 'axios';

import Algo from "./Algo"

import  useAlgoStore from '../../../stores/AlgosStore'
import  useUserStore from '../../../stores/UserStore'

function AlgoStates() {
    const algos = useAlgoStore((state) => state.algos)
    const userID = useUserStore((state) => state.userID) 
    const [selectedList, setSelected] = useState([])

    const abort = async (algo_id) => {
        for (const algo of selectedList) {
            const url = `/api/cancel/cancel_algo/${algo}/blub/blub`
            try {
              await axios.get(url, { timeout: 2000 });
            } catch (err) {
              console.log(err);
            }
          }
          setSelected([])
    }

  return (
    <div className="mobile_state_container">
    {Object.keys(algos).map(function(exchange) {
        return (
            <div className="mobile_state_exchange_container" key={exchange}> 
            {/* <div className="cancel_kill_btn_container">
                <button className="btn cancel_button" onClick={() => abort()}>Cancel</button>
            </div> */}
                <h3 className="states_exchange_title">{exchange.replaceAll(userID+'@', '')}</h3> 
                <ul className="states_ul" key={exchange}> 
                {Object.keys(algos[exchange]).map(function(instrument) {
                    return Object.keys(algos[exchange][instrument]).map(function(side) {
                        return  Object.keys(algos[exchange][instrument][side]).map(function(algo_id) {
                                const algo_unit = algos[exchange][instrument][side][algo_id]
                                return <Algo key={JSON.stringify(algo_unit)} infos={algo_unit}selectedList={selectedList} setSelected={setSelected} />
                        })
                    })
                })}
                </ul>
            </div>
        )
    })}
</div>
  )
}

export default AlgoStates